import React, { useCallback, useEffect, useState } from 'react'
import { TableContainer, } from '@material-ui/core'
import { useMediaQuery } from 'react-responsive'

const TOOLBAR_SHOW_THRESHOLD_PX = 50
const TRANSITION = 'top 0.3s'

export const TableContainerWrapper = ({ columnsVisibilityChanged, ...rest }) => {
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset)
  const [isToolbarVisible, setToolbarVisibility] = useState(true)
  const [manualTrigger, setManualTrigger] = useState(0)
  const isMobile = useMediaQuery({ query: '(max-width: 1224px' })

  useEffect(() => {
    // very ugly solution for following problem:
    // default set of columns in order table is causing difference in header row height 73 vs 81 px
    // it leaves gap between headers and filters. Check below ensures that it is displayed correctly at the beginning
    if (manualTrigger < 100) {
      const timer = setInterval(() => {
        setManualTrigger(manualTrigger + 1)
      }, 250)
      return () => clearInterval(timer)
    }
  }, [manualTrigger])

  useEffect(() => {
    // timeout for setting transition after header rendering so headers don't slide down when they appear
    const timer = setTimeout(() => {
      const filterHeaderThNodes = document.getElementById('filter-headers-row').getElementsByTagName('th')
      for (let filterNode of filterHeaderThNodes) {
        filterNode.style.transition = TRANSITION
      }
      const columnHeaderThNodes = document.getElementById('column-headers-row').getElementsByTagName('th')
      for (let headerNode of columnHeaderThNodes) {
        headerNode.style.transition = TRANSITION
      }

      const tableTabs = document.getElementById('table-tabs')
      if (tableTabs) {
        tableTabs.style.transition = TRANSITION
      }
    }, 50)
    return () => clearTimeout(timer)
  }, [columnsVisibilityChanged])

  useEffect(() => {
    const columnHeadersRow = document.getElementById('column-headers-row')
    const filterHeaderThNodes = document.getElementById('filter-headers-row').getElementsByTagName('th')
    const { offsetHeight: toolbarHeight, style: toolbarStyle } = document.getElementById('toolbar')
    const tableTabs = document.getElementById('table-tabs')
    const tabsHeight = tableTabs?.offsetHeight || 0

    const toolbarTopStyle = (toolbarHeight * !isToolbarVisible)
    toolbarStyle.top = `-${toolbarTopStyle}px`

    const visibleToolbarHeight = isToolbarVisible ? toolbarHeight : 0
    const tableTopOffset = visibleToolbarHeight + tabsHeight
    if (tableTabs) {
      tableTabs.style.top = `${visibleToolbarHeight}px`
    }
    for (let filterNode of filterHeaderThNodes) {
      const topStyle = columnHeadersRow.offsetHeight + tableTopOffset
      filterNode.style.top = `${topStyle}px`
    }
    const columnHeaderThNodes = columnHeadersRow.getElementsByTagName('th')
    for (let headerNode of columnHeaderThNodes) {
      headerNode.style.top = `${tableTopOffset}px`
    }
    const spacer = document.getElementById('table-body-spacer')
    spacer.style.height = `${tableTopOffset}px`
  }, [isToolbarVisible, columnsVisibilityChanged, isMobile, manualTrigger])

  const handleScroll = useCallback(() => {
    const { scrollTop: currentScrollPos } = document.getElementById('table-container')
    if (prevScrollPos !== currentScrollPos) {
      const isScrollUp = prevScrollPos > currentScrollPos
      const isScrollDown = !isScrollUp
      if (isScrollUp && !isToolbarVisible && currentScrollPos < TOOLBAR_SHOW_THRESHOLD_PX) {
        setToolbarVisibility(true)
      } else if (isScrollDown && isToolbarVisible) {
        const { offsetHeight: toolbarHeight } = document.getElementById('toolbar')
        // Taking doubled toolbar height to make sure that toolbar has enough space to hide
        // fix lagging/jumping screen when list takes almost entire page
        // AND to make sure that it has enough space to show again - scrollbar can disappear without this
        if (currentScrollPos > toolbarHeight * 2) {
          setToolbarVisibility(false)
        }
      }
      setPrevScrollPos(currentScrollPos)
    }
  }, [prevScrollPos, isToolbarVisible])

  return <TableContainer {...rest}
                         id={'table-container'}
                         onScroll={handleScroll}/>
}
